<template>
  <div class="agenda">
    <div class="border-bottom-cifra m-b">
      <a
        v-if="infoUsuario.miembro_centro"
        :href="linkHorarios"
        class="btn btn-sm btn-cifra pull-right"
      >
        <i class="fa fa-clock"></i> {{ $I18n.t('Horarios') }}
      </a>
      <a
        v-if="puedeAccederDisponibilidad"
        :href="linkDisponibilidad"
        class="btn btn-sm btn-default pull-right m-r-xs"
      >
        <i class="fa fa-calendar-day"></i> {{ $I18n.t('disponibilidad') }}
      </a>
      <a
        v-if="puedeAccederGuardias"
        :href="linkGuardias"
        class="btn btn-sm btn-default pull-right m-r-xs"
      >
        <i class="fa fa-calendar-day"></i> {{ $I18n.t('guardias') }}
      </a>
      <a
        v-if="puedeReservar"
        :href="linkReservas"
        class="btn btn-sm btn-default pull-right m-r-xs"
      >
        <i class="fa fa-calendar-day"></i> {{ $I18n.t('reservas') }}
      </a>
      <h3 id="calendar-title" class="clearfix">
        <div
          v-if="seleccionado"
          class="clickable dropdown-toggle inline"
          data-toggle="dropdown"
          aria-expanded="false"
        >
          <img
            :src="seleccionado.foto_url"
            class="usuario-thumbnail img-responsive img-circle img-thumbnail usuario-thumbnail-sm"
          />
          {{ seleccionado.nombre }} {{ seleccionado.apellido1 }} {{ seleccionado.apellido2 }}
          <i v-if="usuarios.length > 1" class="fa fa-chevron-down"></i>
        </div>
        <ul v-if="usuarios.length > 1" class="dropdown-menu dropdown-datepicker">
          <li v-for="usuario in usuarios" :key="usuario.id">
            <a
              class="calendar-user count-info"
              @click.prevent="seleccionarUsuario(usuario)"
            >
              <img
                :src="usuario.foto_url"
                class="usuario-thumbnail img-responsive img-circle img-thumbnail
                       usuario-thumbnail-sm"
              />
              {{ usuario.nombre }} {{ usuario.apellido1 }} {{ usuario.apellido2 }}
            </a>
          </li>
        </ul>
      </h3>
    </div>
    <calendario
      ref="calendario"
      :fecha-inicial="fechaInicial"
      :puede-anadir="puedeAnadir"
      :event-source="eventSource"
      @event-render="eventRender"
      @event-new="eventNew"
      @dates-selected="eventNew"
      @event-moved="eventMoved"
      @event-click="eventShow"
    />
  </div>
</template>

<script>
import usuarios from '@/api/usuarios';
import Calendario from '../../components/cifra/Calendario.vue';
import { renderExtraData } from '../../libs/cifra/fullcalendar';

/* global $ */
export default {
  components: { Calendario },
  inject: ['I18n'],
  props: {
    idUsuario: { type: Number, required: true },
    fechaInicial: { type: [String, Date], default: () => new Date() },
    linkHorarios: { type: String, required: true },
    linkReservas: { type: String, default: null },
    linkGuardias: { type: String, default: null },
    linkDisponibilidad: { type: String, default: null },
    puedeReservar: { type: Boolean, default: false },
    puedeAccederGuardias: { type: Boolean, default: false },
    puedeAccederDisponibilidad: { type: Boolean, default: false },
  },
  data() {
    return {
      usuarios: [],
      seleccionado: {},
      infoUsuario: {},
    };
  },
  computed: {
    eventSource() {
      if (!this.seleccionado.id) {
        return null;
      }
      return `/usuarios/${this.seleccionado.id}/eventos`;
    },
    puedeAnadir() {
      return this.infoUsuario.miembro_centro;
    },
  },
  mounted() {
    this._conectarCanalGlobal();

    usuarios.show(this.idUsuario).then((response) => {
      this.infoUsuario = response.data;
      const lista = [this.infoUsuario];
      const tutelados = this.infoUsuario.tutelados || [];
      tutelados.forEach((tutelado) => {
        lista.push(tutelado);
      });
      const [primero] = tutelados;
      if (this.infoUsuario.miembro_centro || !tutelados.length) {
        this.seleccionado = response.data;
      } else {
        this.seleccionado = primero;
      }
      this.usuarios = lista;
    });
  },
  unmounted() {
    this._desconectarCanalGlobal();
  },
  methods: {
    getCalendar() {
      return this.$refs.calendario.getCalendar();
    },
    seleccionarUsuario(usuario) {
      this.seleccionado = usuario;
    },
    eventRender(arg) {
      // Fullcalendar deja los campos estandar en event y los que no son de
      // fullcalendar los mete en event.extendedProps
      const { event, el } = arg;
      const extra = event.extendedProps;

      let tooltip;
      if (extra.desdoble) {
        // Si es un desdoble, mostramos los grupos
        tooltip = `
          <div>${extra.asignatura.nombre}</div>
          <div>${extra.desdoble.curso.nombre_ensennanza} (${this.I18n.t('desdoble')})</div>
          <div>${extra.desdoble.grupos.map((g) => g.nombre).sort().join(', ')}</div>
        `;
      } else if (extra.grupo && extra.asignatura) {
        // Si tiene grupo y asignatura, mostramos ambos
        tooltip = `<div>${extra.asignatura.nombre}</div><div>${extra.grupo.etiqueta}</div>`;
      } else {
        // True genera el tooltip por defecto
        tooltip = extra.tooltip !== undefined ? extra.tooltip : true;
      }

      renderExtraData(arg, { tooltip });

      el.dataset.user = extra.user_id;

      if (el.classList.contains('anotacion-diario')) {
        el.appendChild(this.crearAnotacionDiarioLink(extra));
      }
    },
    // Lo dejamos tal como estaba con jQuery, a futuro ya veremos
    eventNew(info) {
      if (!this.puedeAnadir) {
        return;
      }

      const params = {
        todo_el_dia: info && info.allDay,
      };

      if (info) {
        if (info.start) {
          params.inicio = info.start.toISOString();
        }
        if (info.end) {
          params.fin = info.end.toISOString();
        }
      }

      $.get('/eventos/new', params);
    },
    eventMoved(info) {
      const { event } = info;
      $.ajax({
        url: `/eventos/${event.id}`,
        method: 'PATCH',
        data: {
          inicio: event.start,
          fin: event.end,
          todo_el_dia: event.allDay,
          auto: true,
        },
        error() {
          info.revert();
        },
      });
    },
    eventShow(info) {
      const { event } = info;
      const extra = event.extendedProps;

      if (info.event.url || !extra.clickable) {
        return;
      }
      $.get(`/eventos/${info.event.id}`);
    },
    crearAnotacionDiarioLink(data) {
      const searchParams = new URLSearchParams();
      searchParams.set('fecha', data.fecha);
      searchParams.set('asignatura', data.asignatura.id);
      searchParams.set('grupo', data.grupo.id);

      const link = document.createElement('a');
      link.classList.add('fc-event-diario');
      link.setAttribute('data-controller', 'modal-remoto');
      link.setAttribute('href', `/eventos/anotacion-diario?${searchParams.toString()}`);
      link.innerHTML = '<i class="fas fa-comment anotacion"></i>';
      return link;
    },
    _conectarCanalGlobal() {
      // para que el this del evento sea el componente vue hay que hacer el bind
      // y desconectar después la función con el bind
      this.callbackRecargar = this.listenRefresh.bind(this);
      document.addEventListener('recargar-agenda', this.callbackRecargar);
    },
    _desconectarCanalGlobal() {
      document.removeEventListener('recargar-agenda', this.callbackRecargar);
    },
    listenRefresh() {
      this.getCalendar().refetchEvents();
    },
  },
};
</script>
<style scoped lang="scss">
  // Este css es para que no muestre la hora, que centre
  // vertical y horizontalmente el texto etc.
  .agenda {
    :deep(.calendario) {
      .fc {
        .fc-timegrid-slot-minor {
          border-top: none;
        }
        .fc-event-time {
          display: none;
        }
        .fc-event-title {
          text-align: center;
        }
        .fc-event-main-frame {
          align-items: center;
          justify-content: center;
        }
        .fc-event-title-container {
          flex-grow: 0;
        }
      }
    }
  }
</style>
